import { render, staticRenderFns } from "./qNav.vue?vue&type=template&id=6f834294&"
import script from "./qNav.vue?vue&type=script&lang=ts&"
export * from "./qNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports